// Subtle analog grain layered across the whole page for a printed, gallery feel.
export default function GrainOverlay() {
  return <div className="grain-overlay" aria-hidden="true" data-testid="grain-overlay" />;
}
